/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2023-07-24 15:18:43
 * @LastEditors: WangQi
 * @LastEditTime: 2023-07-24 15:25:08
 */
// 数据统计
const map = {
  itemSold: () => import('@/views/dataanalysis/ItemSalesSummary'),
  dataOverview: () => import('@/views/dataanalysis/DataOverview'),
  statisticsRepurchaseRate: () => import('@/views/dataanalysis/StatisticsRepurchaseRate') // 复购页面
}

export default map
